module.exports = __webpack_public_path__ + "img/mini-025.503b5d46.jpg";